import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { Banks as BanksPresenter } from './presenter';
import { set as setUI, clear, merge } from '../../../common/actions/ui';
import { connect } from '../../../common/react-redux';
import { getBanks } from '../../../banks/api/banks';
import * as modalActions from '../../../common/actions/modal';
import { createBank } from '../../../common/actions/modifications';
import { featureOn } from '../../../common/util/featureCheck';
import { BANKS_BANK_FILTERS } from '@instructure/quiz-common';
function mapStateToProps(state, props) {
  var pageData = state.getIn(['ui', BANKS_BANK_FILTERS], Map());
  var scopeType = pageData.get('scopeType', (props.scope || {}).type || 'user');
  var sortBy = pageData.get('sortBy', 'name');
  var sortOrder = pageData.get('sortOrder', 'ascending');
  var searchTerms = pageData.get('searchTerms', null);
  var searchSelection = pageData.get('searchSelection', []);
  var rootAccountUuid = state.getIn(['outcomes', 'externalAccountUuid']);
  return {
    itemBankSearchTableEnabled: featureOn('item_bank_search_table'),
    usedByCourseEnabled: featureOn('filter_item_banks_used_by_course'),
    scopeType: scopeType,
    sortBy: sortBy,
    sortOrder: sortOrder,
    searchTerms: searchTerms,
    searchSelection: searchSelection,
    rootAccountUuid: rootAccountUuid
  };
}
function mapDispatchToProps(dispatch) {
  return {
    createBank: bindActionCreators(createBank, dispatch),
    getBanks: bindActionCreators(getBanks, dispatch),
    openModal: bindActionCreators(modalActions.openModal, dispatch),
    clear: bindActionCreators(clear, dispatch),
    merge: bindActionCreators(merge, dispatch),
    setUI: bindActionCreators(setUI, dispatch)
  };
}
export var Banks = connect(mapStateToProps, mapDispatchToProps)(BanksPresenter);
export default Banks;